export enum EUsernameField {
  USERNAME_CONTAINER = "USERNAME_CONTAINER",
  USERNAME_INPUT = "USERNAME_INPUT",
  ERROR_LIST_ELEMENTS = "ERROR_LIST_ELEMENTS",
}
